import {
	FETCH_DATA_SUCCESS,
	LOGOUT_USER,
} from '../types';

const initialState = {
	messages: [],
}

const data = (state = initialState, action) => {
	switch(action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				messages: action.payload.messages,
			}

		case LOGOUT_USER:
			return initialState

		default:
			return state;
	}
}
export default data;

export const getMessages = state => {
	return state.messages;
}
export const getMessageById = (state, id) => {
	return state.messages.find(message => message.id === id);
}


// WEBPACK FOOTER //
// ./src/store/data/reducer.js